import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ExportCollect } from 'contracts/Collects';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'EXPORT_COLLECTS_',
  }
);

export interface ExportCollectsState {
  data: ExportCollect[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ExportCollectsRequestAction {
  query?: Record<string, any>;
  onSuccess?: (data: ExportCollect[]) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ExportCollect[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ExportCollectsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ExportCollectsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ExportCollectsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ExportCollectsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ExportCollectsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const exportCollects = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ExportCollectsTypes = Types;
export const ExportCollectsActions = Creators;
